import { render } from "./Program.vue?vue&type=template&id=4721a440&scoped=true"
import script from "./Program.vue?vue&type=script&lang=js"
export * from "./Program.vue?vue&type=script&lang=js"

import "./Program.vue?vue&type=style&index=0&id=4721a440&scoped=true&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.43_vue@3.5.43_webpack@5.111.1_postcss@8.5.29_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4721a440"]])

export default __exports__